import Sidebar from '../../../../shared-components/sidebar/Sidebar';

export default Sidebar;



// WEBPACK FOOTER //
// ./src/custom/abbrasil/shared-components/sidebar/Sidebar.js